import React, { FC } from 'react'
import classNames from 'classnames'
import styles from 'styles/components/card.module.scss'
import typography from 'styles/components/typography.module.scss'
import text from 'styles/utility/text.module.scss'
import { FlexRow } from 'components/Flex'
import { Spacer } from 'components/Utility'
import { SmallLabel } from 'components/Label'
import { BreadPreorderTag, LightTag } from 'components/Tag'
import { BlueButton, CautionButton } from 'components/Button'
import { FirebaseDocRefType } from 'firebase/index'
import { useQueryStockAmountByBreadRef } from 'hooks/stock'
import { useQueryStoreNameByBreadRef } from 'hooks/store'

type Props = {
  breadRef: FirebaseDocRefType
  breadName: string
  handleBreadIds?: (breadId: string) => void
  isAdded?: boolean
  isTypeDaily: boolean
  isTypePreorder: boolean
  isTypeDelivery: boolean
  imageUrl: string
}

const CampaignBreadCard: FC<Props> = React.memo((props) => {
  const { handleBreadIds, breadRef, breadName, isAdded, isTypeDaily, isTypePreorder, isTypeDelivery, imageUrl } = props
  const preorderStockAmount = useQueryStockAmountByBreadRef(breadRef)
  const storeName = useQueryStoreNameByBreadRef(breadRef)
  return (
    <div className={styles.row__inner}>
      <FlexRow justifyContent={'start'} alignItems={'start'}>
        <div className={classNames(styles.row__image)}>
          <img src={imageUrl} alt={breadName} />
        </div>
        <Spacer size={12} />
        <div className={styles.row__body}>
          <FlexRow justifyContent={'between'} alignItems={'start'}>
            <div>
              <h4 className={classNames(typography.headline_small)}>{breadName}</h4>
              <Spacer size={8} />
              <p className={classNames(text.font_small)}>{storeName}</p>
            </div>
            <Spacer size={12} />
            {handleBreadIds &&
              (isAdded ? (
                <CautionButton
                  label={'削除'}
                  onClick={() => handleBreadIds(breadRef.id)}
                  size={'xxsmall'}
                  type={'outlined'}
                />
              ) : (
                <BlueButton
                  label={'追加'}
                  onClick={() => handleBreadIds(breadRef.id)}
                  size={'xxsmall'}
                  type={'outlined'}
                />
              ))}
          </FlexRow>
          <Spacer size={8} />
          <FlexRow justifyContent={'start'}>
            <SmallLabel label={'注文タイプ ： '} />
            {isTypeDaily && (
              <div className={styles.tag__item}>
                <LightTag color={'blue'} label={'当日'} />
              </div>
            )}
            {isTypePreorder && (
              <div className={styles.tag__item}>
                <BreadPreorderTag isConfigured={preorderStockAmount > 0} />
              </div>
            )}
            {isTypeDelivery && (
              <div className={styles.tag__item}>
                <LightTag color={'orange'} label={'取り寄せ'} />
              </div>
            )}
          </FlexRow>
        </div>
      </FlexRow>
    </div>
  )
})

export default CampaignBreadCard
